export const env = {
  SERVER_URL: process.env.NEXT_PUBLIC_SERVER_URL,
  PACKAGE_SERVER_URL: process.env.NEXT_PUBLIC_PACKAGE_SERVER_URL,
  COMMUNITY_ID: process.env.NEXT_PUBLIC_COMMUNITY_ID,
  NEXT_PUBLIC_AMPLITUDE_API_KEY: process.env.NEXT_PUBLIC_AMPLITUDE_API_KEY,
};
